const Telegram = window.Telegram;

export const isMobile = (): boolean => {
  return ['android', 'ios'].includes(Telegram?.WebApp?.platform ?? '');
};
